const AMPLITUDE_EVENTS = {
  FILTERING_APIS: "Filtering the Apis",
  REMOVE_APIS: "Removed ApiType from Api Directory",
  REMOVE_FILTER: "Removed filters from Api Directory",
  REMOVE_CATEGORY: "Removed Category from Api Directory",
  SHOW_MORE_APIS: "Show the More Apis",
  SEARCH_APIS: "Searching APIs",
  API_OVERVIEW: "To View Api Overview",
  VIEW_SPECIFICATION: "To View Api Endpoints and Specification",
  VIEW_PRICING: "To View Api Pricing Plans",
  VIEW_DOCUMENTATION: "To access Api Documentation",
  OPEN_CONTACT: "To open Api Contacts",
  SELECTED_API_TYPE: "Selected ApiType from api Directory",
  SELECTED_CATEGORY_TYPE: "Selected Category from Api Directory",
  DEALER_API_DETAILS_OVERVIEW: "Dealer API Details Overview",
  DEALER_API_DETAILS_PRICING: "Dealer API Details Pricing",
  DEALER_API_DETAILS_SPECIFICATIONS: "Dealer API Details Specifications",
  DEALER_API_DETAILS_DOCUMENTATION: "Dealer API Details Documentation",
  DEALER_API_DETAILS_CONTACT: "Dealer API Details Contact",
  DEALER_BUNDLE_DETAILS_OVERVIEW: "Dealer Bundle Details Overview",
  DEALER_BUNDLE_DETAILS_SPECIFICATIONS: "Dealer Bundle Details Specifications",
  DEALER_BUNDLE_DETAILS_PRICING: "Dealer Bundle Details Pricing",
  DEALER_API_DIRECTORY_FILTER_BY: "Dealer API Directory Filter By",
  DEALER_API_DIRECTORY_COMPARE_API_PLANS:
    "Dealer API Directory Compare API Plans",
  ISV_API_DIRECTORY_COMPARE_API_PLANS: "ISV API Directory Compare API Plans",
};

const AMPLITUDE_PROPERTIES = {
  FILTER_TYPE: "Filter Name",
  IS_SELECTED: "Is Checked",
  SELECTED_FIELDS: "Selected Fields",
  REMOVE_API: "Removed Selected Apis",
  REMOVE_CATEGORY: "Removed Categories from api directory",
  REMOVE_FILTER: "Removed filters from api Directory",
  MORE_APIS: "More Apis",
  SEARCH_APIS: "Search Apis",
  SELECTED_API_TYPE: "Selected ApiType",
  SELECTED_CATEGORY: "Selected Category",
  FIND_CURRENT_TAB: "Current Tab",
  ORG_NAME: "Org Name",
  ORG_ID: "Org ID",
  USER_NAME: "User Name",
  USER_ID: "User ID",
};

export { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES };
